import React from 'react';

export default function EnquiryForm({
  isOpen,
  onClose,
  formData,
  setFormData,
  onSubmit
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 backdrop-blur-sm">
      <div
        className="
        bg-white
        w-full
        sm:max-w-md
        max-h-[90vh]
        rounded-t-2xl sm:rounded-2xl
        shadow-xl
        relative
        flex
        flex-col
      "
      >
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 z-10 text-gray-600 hover:text-red-500 text-xl"
          onClick={onClose}
        >
          ✕
        </button>

        {/* Scrollable Content */}
        <div className="p-4 sm:p-6 overflow-y-auto flex-1">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4">
            Enquiry Now
          </h2>

          <form className="space-y-3 sm:space-y-4" onSubmit={onSubmit}>
            {[
              { label: 'Destination', value: formData.destination },
              { label: 'Plan', value: formData.plan },
              { label: 'Price', value: formData.price }
            ].map((item) => (
              <div key={item.label}>
                <label className="block text-sm font-medium text-gray-600">
                  {item.label}
                </label>
                <input
                  type="text"
                  className="w-full p-2.5 border rounded bg-gray-100 text-sm"
                  value={item.value}
                  disabled
                />
              </div>
            ))}

            <div>
              <label className="block text-sm font-medium text-gray-600">
                Your Name
              </label>
              <input
                type="text"
                required
                className="w-full p-2.5 border rounded text-sm"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-600">
                Phone
              </label>
              <input
                type="tel"
                required
                className="w-full p-2.5 border rounded text-sm"
                value={formData.phone}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-600">
                Email
              </label>
              <input
                type="email"
                className="w-full p-2.5 border rounded text-sm"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
            </div>

            <button
              className="
              w-full
              bg-blue-600
              text-white
              py-3
              rounded-lg
              text-sm sm:text-base
              hover:bg-blue-700
              transition
            "
            >
              Submit Enquiry
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
